import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useLang } from '../../hooks/useLang'

const Seo = ({ seomatic, hreflangs = {} }) => {
  const {
    site: {
      siteMetadata: { siteUrl },
    },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `,
  )
  const lang = useLang()

  const metaTitleContainer = JSON.parse(seomatic.metaTitleContainer)
  const metaTagContainer = JSON.parse(seomatic.metaTagContainer)
  const meta = Object.keys(metaTagContainer)
    .filter(
      key => !['og:url'].includes(key) && !Array.isArray(metaTagContainer[key]),
    )
    .map(name => ({
      name,
      ...metaTagContainer[name],
    }))

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitleContainer.title.title}
      bodyAttributes={{ class: 'antialiased font-sans bg-gray-1' }}
      meta={meta}
    >
      {Object.entries(hreflangs).map(([key, value]) => (
        <link
          key={key}
          rel="alternate"
          href={`${siteUrl}${value}`}
          hreflang={key}
        />
      ))}
      <link
        rel="alternate"
        href={`${siteUrl}${hreflangs.de}`}
        hreflang="x-default"
      />
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-document-language="true"
        type="text/javascript"
        charset="UTF-8"
        data-domain-script="4c8d6e47-35ea-4607-b581-6be6fd295192-test"
      ></script>
      <script type="text/javascript">{`
        function OptanonWrapper() {}
      `}</script>
    </Helmet>
  )
}

export default Seo
